import { CartItemCustomizations } from "./CartItemCustomizations";
import { DisplayOptions } from "../menu/DisplayOptions";

export class CartItem {
    cartItemId: string;
    itemId: string;
    itemVersion: number | null;
    title: string;
    price: number;
    deliveryPrice:number;
    quantity: number;
    customizations: CartItemCustomizations[];
    note:string | null;
    parentCategoryDisplayOptions:DisplayOptions | null;
    displayOptions:DisplayOptions | null;

    constructor(cartItemId: string, itemId: string, itemVersion: number | null, title: string, price: number, deliveryPrice:number, 
        quantity: number, customizations: CartItemCustomizations[], note:string | null, parentCategoryDisplayOptions:DisplayOptions | null, displayOptions:DisplayOptions | null) {
        this.cartItemId = cartItemId;

        this.itemId = itemId;
        this.itemVersion = itemVersion;

        this.title = title;
        this.price = price;
        this.deliveryPrice = deliveryPrice;
        this.quantity = quantity;
        this.note = note;
        this.customizations = customizations;
        this.parentCategoryDisplayOptions = parentCategoryDisplayOptions;
        this.displayOptions = displayOptions;
    }

    getUsedPrice(isDelivery:boolean){
        return isDelivery?this.deliveryPrice:this.price;
    }

    toAwsObject() {
        let cartItemObj: any = {
            "cartItemId": this.cartItemId,

            "itemId": this.itemId,

            "title": this.title,
            "price": this.price,
            "deliveryPrice": this.deliveryPrice,
            "quantity": this.quantity,
            "customizations":{}
        }

        if(this.note!=null){
            cartItemObj["note"] = this.note;
        }
        if(this.itemVersion){
            cartItemObj["itemVersion"] = this.itemVersion;
        }
    
        this.customizations.forEach((custom,index)=>{
            cartItemObj["customizations"][index] = custom.toAwsObject();
        })

        if(this.parentCategoryDisplayOptions!=null){
            cartItemObj["parentDisplayOptions"] = this.parentCategoryDisplayOptions.toAwsObject();
        }
        if(this.displayOptions!=null){
            cartItemObj["displayOptions"] = this.displayOptions.toAwsObject();
        }

        return cartItemObj;
    }

    static newFromAws(awsData:any){
        let subItemsList:CartItemCustomizations[] = [];
        if(awsData.customizations!=null){
            Object.keys(awsData.customizations).forEach(key => {
                subItemsList.push(CartItemCustomizations.newFromAws(awsData.customizations[key]))
            });
        }

        return new CartItem(
            awsData.cartItemId,
            awsData.itemId,
            awsData.itemVersion,
            awsData.title,
            awsData.price,
            awsData.deliveryPrice,
            awsData.quantity,
            subItemsList,
            awsData.note,
            DisplayOptions.newFromAWS(awsData.parentDisplayOptions),
            DisplayOptions.newFromAWS(awsData.displayOptions),
        );
    }
}